import { Stack } from '@chakra-ui/react';
import { Alert } from '@time-line/components/common';
import type { ReactNode } from 'react';
import type { Variant } from 'types/product/Variant';

import { ProductCtas } from '../ProductCtas';
import { ProductSoldOut } from '../ProductSoldOut';
import type { BaseConfiguratorProps } from '.';

interface WrapperProps extends Omit<
  BaseConfiguratorProps,
  'showSavingsAsAmount'
> {
  className: string;
  availableForSale: boolean;
  variant: Variant;
  otpVariant: Variant;
  children: ReactNode;
  showOTPLink?: boolean;
}

export function Wrapper({
  className,
  availableForSale,
  infoBox,
  variant,
  otpVariant,
  children,
  promoCodes,
  ...props
}: WrapperProps) {
  return (
    <Stack className={className} spacing="2xs">
      {!availableForSale ? (
        <ProductSoldOut price={otpVariant.price} />
      ) : (
        children
      )}
      {infoBox && <Alert status="info">{infoBox}</Alert>}
      <ProductCtas
        variant={variant}
        otpVariant={otpVariant}
        promoCodes={promoCodes}
        {...props}
      />
    </Stack>
  );
}
